import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input", "label"];

  connect() {
    // Check if input has value on page load
    this.updateLabelState();
  }

  focus() {
    this.labelTarget.classList.add("floating-label-focused");
  }

  blur() {
    this.updateLabelState();
  }

  input() {
    this.updateLabelState();
  }

  // Open the native date picker on click. Browsers (Chromium, Safari 16.4+)
  // expose showPicker() on date inputs but don't auto-open on click.
  showPicker(event) {
    if (this.inputTarget.type !== "date") return;
    if (typeof this.inputTarget.showPicker !== "function") return;
    try {
      this.inputTarget.showPicker();
      event.preventDefault();
    } catch (_) {
      // Safari throws if user gesture isn't recognized — fall back to focus.
      this.inputTarget.focus();
    }
  }

  updateLabelState() {
    // Date inputs always render mm/dd/yyyy placeholder ghost text, so their
    // label must always float to avoid overlapping it — keep it floated even
    // when empty.
    if (this.inputTarget.type === "date") {
      this.labelTarget.classList.add("floating-label-focused");
      return;
    }

    const hasValue = this.inputTarget.value.length > 0;

    if (hasValue) {
      this.labelTarget.classList.add("floating-label-focused");
    } else {
      this.labelTarget.classList.remove("floating-label-focused");
    }
  }
}
